import React, { useEffect, useRef } from "react";
import { FacebookProvider, Comments } from "react-facebook";

const FbComments = (props) => {
  let intervalId = useRef();

  useEffect(() => {
    intervalId.current = setInterval(() => {
      if (typeof window.FB !== undefined) {
        window.FB.Event.subscribe("xfbml.render", () => {
          props.onReady();
          clearInterval(intervalId.current);
        });
      }
    }, 500);
  }, [props]);

  return process.env.GATSBY_FB_APP_ID ? (
    <FacebookProvider appId={process.env.GATSBY_FB_APP_ID}>
      <Comments width={"100%"} href={props.href} />
    </FacebookProvider>
  ) : (
    <></>
  );
};

export default FbComments;
